export const noDcrsOverlayStyles = {
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		gap: 4,
		pb: 4
	},
	title: {
		fontWeight: 700,
		fontSize: 20
	},
	icon: {
		color: 'text.secondary',
		width: '145px',
		height: '145px'
	}
};
